export const COMPARTMENT_DOORS_GALLERY_LIST_PRESET = [
  {
    displayedName: 'Двери-купе',
    mediaMainPhoto: ['1.jpg/1.jpg'],
    price: 41894,
    style: 'compartment-doors',
    rating: 1000,
  },
  {
    displayedName: 'Двери-купе',
    mediaMainPhoto: ['2.jpg/2.jpg'],
    price: 76200,
    style: 'compartment-doors',
    rating: 1014,
  },
  {
    displayedName: 'Двери-купе',
    mediaMainPhoto: ['3.jpg/3.jpg'],
    price: 57356,
    style: 'compartment-doors',
    rating: 1005,
  },
  {
    displayedName: 'Двери-купе',
    mediaMainPhoto: ['4.jpg/4.jpg'],
    price: 64862,
    style: 'compartment-doors',
    rating: 1011,
  },
  {
    displayedName: 'Двери-купе',
    mediaMainPhoto: ['5.jpg/5.jpg'],
    price: 60600,
    style: 'compartment-doors',
    rating: 1008,
  },
  {
    displayedName: 'Двери-купе',
    mediaMainPhoto: ['6.jpg/6.jpg'],
    price: 62866,
    style: 'compartment-doors',
    rating: 1023,
  },
  {
    displayedName: 'Двери-купе',
    mediaMainPhoto: ['7.jpg/7.jpg'],
    price: 60002,
    style: 'compartment-doors',
    rating: 1020,
  },
  {
    displayedName: 'Двери-купе',
    mediaMainPhoto: ['8.jpg/8.jpg'],
    price: 49682,
    style: 'compartment-doors',
    rating: 1017,
  },
];
